import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from "@/components/ui/dialog";
import { Settings, FileSpreadsheet, Save } from "lucide-react";
import { LanguageStore } from "@/Services/LanguageStore";
import { BridgeLanguage } from "@/Services/Language";
import { decodeWithBase64 } from "@/Services/encodedecode";

interface SettingsDialogProps {
  deployment: {
    id: string;
    name: string;
    sheetsUrl: string;
  };
  onClose: () => void;
  onUpdate: (deployment: any) => void;
}

const SettingsDialog = ({ deployment, onClose, onUpdate }: SettingsDialogProps) => {
  const [name, setName] = useState(deployment.name);
  const [sheetsUrl, setSheetsUrl] = useState(deployment.sheetsUrl);

  const LanguageString = (number: any) => {
    let LangData = LanguageStore.allLanguages;
    if (Object.keys(LangData).length === 0) {
      let localLang = localStorage.getItem('BridgeLanguageStrings');
      if (localLang) {
        LangData = JSON.parse(decodeWithBase64(localLang));
      }
    }
    if (LangData && LangData[number]) {
      return LangData[number];
    }
    else {
      return BridgeLanguage(number);
    }
  }

  const handleSave = () => {
    onUpdate({
      ...deployment,
      name,
      sheetsUrl
    });
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2">
            <Settings className="h-5 w-5" />
            <span>{LanguageString("2168")}</span>
          </DialogTitle>
          <DialogDescription>
            {LanguageString("2169")}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="agentName">{LanguageString("DeviceName")}</Label>
            <Input
              id="agentName"
              value={'Cosmitude Email tracker agent'}
              disabled
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="sheetsUrl">{LanguageString("2060")}</Label>
            <div className="relative">
              <FileSpreadsheet className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
              <Input
                id="sheetsUrl"
                value={sheetsUrl}
                onChange={(e) => setSheetsUrl(e.target.value)}
                className="pl-10"
              />
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {LanguageString("Cancel")}
          </Button>
          <Button onClick={handleSave}>
            <Save className="h-4 w-4 mr-2" />
            {LanguageString("2166")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;